import { useState } from "react";
import { Card, PageHeader, Input, Select, Btn, Table, Modal } from "../../components/shared/UIComponents";

export function UserRights() {
  const modules = {
    Admin: ["Manage Society", "Email Configuration", "Manage Member", "Upload Documents", "Notice Manager", "Event Manager", "Helpdesk Tickets", "Sub Committee", "Assets Management", "Staff Management", "Add", "Delete"],
    Accounts: ["Vendor Management", "Set Account", "Account Master", "Budget", "Set Charges", "Bill Parameters", "Bill Generation", "Bank Reconciliation", "Add", "Delete"],
    Transactions: ["Transaction Menu", "Receipts", "Payments", "General Receipts", "Contra", "Debit Note/Credit Note/JV", "Add", "Delete", "Export To Excel"],
    Reports: ["Bank & Cash Reports", "Income & Expense Tracker", "Members Reports", "Final Accounts", "Finance Tracker", "Export To Excel"],
  };
  const [checked, setChecked] = useState({ Transactions: { Receipts: true } });
  const toggle = (mod, item) => setChecked(p => ({ ...p, [mod]: { ...p[mod], [item]: !p[mod]?.[item] } }));
  return (
    <Card>
      <PageHeader title="Set User Rights" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", gap: 14, alignItems: "flex-end", marginBottom: 20 }}>
          <Select label="Select User" options={["bhoomiF0102-Abhishek Singh", "bhoomiF0103-Ashok Kumar", "bhoomiF0104-Sohail V Bhagat"]} style={{ minWidth: 280 }} />
          <Btn>Save</Btn>
        </div>
        <div style={{ fontSize: 12, color: "#607d8b", marginBottom: 16 }}>• Select Checkboxes and then press Save. &nbsp;&nbsp;• You can select all checkboxes by clicking on Select All checkbox.</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16 }}>
          {Object.entries(modules).map(([mod, items]) => (
            <div key={mod} style={{ border: "1px solid #e8eaf0", borderRadius: 10, overflow: "hidden" }}>
              <div style={{ background: "#f5f7fa", padding: "10px 14px", borderBottom: "1px solid #e8eaf0", display: "flex", alignItems: "center", gap: 8 }}>
                <input type="checkbox" style={{ accentColor: "#1565c0" }} defaultChecked />
                <span style={{ fontWeight: 600, color: "#1a2744", fontSize: 13 }}>{mod}</span>
              </div>
              <div style={{ padding: "8px 14px 12px" }}>
                {items.map(item => (
                  <label key={item} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12.5, color: "#455a64", marginBottom: 6, cursor: "pointer" }}>
                    <input type="checkbox" checked={!!checked[mod]?.[item]} onChange={() => toggle(mod, item)} style={{ accentColor: "#1565c0" }} />
                    {item}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

export function SubCommittee() {
  const categories = ["Lift Maintenance Issues", "Data Correction", "Common Facility Usage", "Housekeeping Issues", "Gardening Problem", "Security Related Issues", "Parking Problem", "Office Administration", "Electricity Issues", "CCTV Camera not working", "Online Payment Issues", "Suggestions", "Water Related Problm", "Billing Accounts Not proper", "Bill Related Issues"];
  const [facilities] = useState([{ t: "Data Correction" }, { t: "Common Facility Usage" }, { t: "CCTV Camera not working" }, { t: "Parking Problem" }]);
  const [showMembersModal, setShowMembersModal] = useState(false);
  return (
    <Card>
      <PageHeader title="Sub Committee" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
          <Select label="Sub Commitee Title" options={["Select", ...categories]} />
          <Select label="List of Member" options={["None selected", "Abhishek Singh", "Ashok Kumar", "Sohail V Bhagat"]} />
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 24 }}><Btn>Add New Committee</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        <Table columns={["SrNo", "Title", "Edit", "Delete", "Print"]} rows={facilities}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.t}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
            <td style={{ padding: "9px 12px" }}><button onClick={() => setShowMembersModal(true)} style={{ background: "#e3f2fd", color: "#1565c0", border: "none", borderRadius: 5, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Open</button></td>,
          ]}
        />
      </div>
      {showMembersModal && (
        <Modal title="Sub Committee Members" onClose={() => setShowMembersModal(false)}>
          <Table columns={["SrNo", "Title", "Name", "Email", "Phone", "Flat No"]}
            rows={[
              { t: "Data Correction", n: "Abhishek Singh", e: "as@gmail.com", p: "9125100106", f: "bhoomiF0102~F0102" },
              { t: "Data Correction", n: "Ashok Kumar", e: "abc@gmail.com", p: "9643287776", f: "bhoomiF0103~F0103" },
              { t: "Data Correction", n: "Sohail V Bhagat", e: "bombay@gmail.com", p: "9765432765", f: "bhoomiF0104~F0104" },
            ]}
            renderRow={(r, i) => [
              <td style={{ padding: "8px 10px" }}>{i + 1}</td>,
              <td style={{ padding: "8px 10px" }}>{r.t}</td>,
              <td style={{ padding: "8px 10px", fontWeight: 500 }}>{r.n}</td>,
              <td style={{ padding: "8px 10px", fontSize: 12 }}>{r.e}</td>,
              <td style={{ padding: "8px 10px" }}>{r.p}</td>,
              <td style={{ padding: "8px 10px" }}>{r.f}</td>,
            ]}
          />
          <div style={{ textAlign: "right", marginTop: 16 }}><Btn bg="#607d8b" onClick={() => setShowMembersModal(false)}>Close</Btn></div>
        </Modal>
      )}
    </Card>
  );
}

export function StaffManagement() {
  const [staff] = useState([{ n: "shyam", s: "staff", p: "6666678732", d: "2025-08-20" }]);
  return (
    <Card>
      <PageHeader title="Staff Management" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
          <div style={{ gridColumn: "span 2" }}><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="checkbox" style={{ accentColor: "#1565c0" }} /> Assign User Rights</label></div>
          <Input label="UserName" placeholder="Enter UserName" />
          <Input label="Password" type="password" placeholder="Enter Password" />
          <Input label="Confirm Password" type="password" placeholder="Enter Confirm Password" />
          <Select label="Service/Designation" options={["Select", "Manager", "Staff", "Security", "Housekeeping", "Electrician", "Plumber"]} />
          <Input label="Staff Name" placeholder="Enter Staff Name" />
          <Input label="Phone Number 1" placeholder="Enter Phone No" />
          <Input label="Phone Number 2" placeholder="Enter Phone No" />
          <Input label="Date of Joining" type="date" />
          <Input label="Date of Relieving" type="date" />
          <Input label="Salary" placeholder="Enter Salary" />
          <div>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Sex</label>
            <div style={{ display: "flex", gap: 14, marginTop: 8, fontSize: 13 }}>
              <label><input type="radio" name="sex" defaultChecked /> Male</label>
              <label><input type="radio" name="sex" /> Female</label>
            </div>
          </div>
          <Input label="Email Address" placeholder="Enter EmailId" />
          <Input label="Comment" placeholder="Enter Comments" />
          <Select label="Select Facility" options={["Select", "Cleaning", "Security", "Maintenance", "Gardening", "Electrical"]} />
          <div style={{ gridColumn: "span 2", display: "flex", gap: 10 }}><Btn>Save</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        </div>
        <div style={{ fontWeight: 600, color: "#546e7a", fontSize: 13, marginBottom: 12 }}>📋 Staff Details</div>
        <Table columns={["SrNo", "Staff Name", "Service", "Phone Number", "Date of Join", "Edit", "Delete"]} rows={staff}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
            <td style={{ padding: "9px 12px" }}>{r.s}</td>,
            <td style={{ padding: "9px 12px" }}>{r.p}</td>,
            <td style={{ padding: "9px 12px" }}>{r.d}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export default UserRights;
